import {
    obj_forEach_f,
    obj_toString_fs,
    obj_size_fn,
    obj_deepCopy_f,
    obj_equals_fb
} from "../../../functions/src/shareCode/Share_S_Obj";
import {validator_obj_fb, validator_objEmpty_fb} from "../../../functions/src/shareCode/Share_S_Validator";
import {gv_fun_env} from "../../../functions/src/shareCode/Share_Ass_GlobalVariable";
import { cacheServer_get_fo, cacheServer_save_f } from "./S_CacheServer";

let fbData_byJsonTree_o = {}
let cbs_byJsonTree_byViewName_o = {
    "$path" : {
        cbsData_byQuery_o : {
            "$query" : {
                cbData_byViewName_o:{
                    "$viewName" : {
                        cb_f : () => {},
                        childListener_b : false,
                        // cacheFallback_b : false,
                    }
                },
                cacheFallback_b     : false,
                receivedData_b  : true,
                oneTimeCbs_af   : [],
                index2_n        : 1
            }
        }
    } // example
}

const debug_listeners_byPath_o = {}

// serverStorage_getDataOnce_f
export const serverLocalStorage_getDataOnce_f = ({path_as, query_os={}, getOnlyFromServer_b=false, cacheFallback_b=false, getServerData_f,  cb_f}) => {
    let query_s = obj_toString_fs(query_os)

    getLocalData_f(path_as, (currentNode_cbs_o, currentNode_data_o, path_s) => {

        let currentData_o = currentNode_data_o ? currentNode_data_o[path_s] : null

        // 1) return local data
        if((currentNode_cbs_o[path_s].cbsData_byQuery_o
            && currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s]
            && currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].receivedData_b)
            && !getOnlyFromServer_b){

            callCbWithData_f(currentData_o, query_os, false, null, cb_f)

        // 2) call server
        } else if(currentNode_cbs_o[path_s].cbsData_byQuery_o == null
            || currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s] == null
            || currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].oneTimeCbs_af == null){

            // 1.1 add current cb
            if (currentNode_cbs_o[path_s].cbsData_byQuery_o == null) {
                currentNode_cbs_o[path_s] = {cbsData_byQuery_o: {}}
            }
            if (currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s] == null
                || currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].oneTimeCbs_af == null) {
                currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s] = {oneTimeCbs_af: []}
            }

            currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].oneTimeCbs_af.push(cb_f)

            // 1.2) call server
            getServerData_f(
                (data_o) => {
                    if(cacheFallback_b){
                        cacheServer_save_f(path_as, query_s, data_o)
                    }
                    updateData_f(data_o)
                }, 
                ()=> {
                    if(cacheFallback_b){
                        const cahcedData_o = cacheServer_get_fo(path_as, query_s)
                        updateData_f(cahcedData_o)
                    }
                })
            
            // updateData_f
            const updateData_f = (data_o) => {
                // 1.2.1 save data
                updateLocalStorage_fb(path_as, data_o)

                // 1.2.2 call all cbs
                currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].oneTimeCbs_af.forEach(localCb_f => {
                    callCbWithData_f(data_o, query_os, false, null, localCb_f)
                })

                // 1.2.3 delete all oneTime callbacks
                currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].oneTimeCbs_af = null

                // 1.2.4 receivedData
                currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].receivedData_b = true
            }

        // 3) calledServerWaitingForData
        } else{
            currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].oneTimeCbs_af.push(cb_f)

        }
    })
}

// serverStorage_dataChange_f
export const serverLocalStorage_dataChange_f = ({path_as, query_os={}, data, cacheFallback_b=false}) => {

    const query_s = obj_toString_fs(query_os)

    // update data todo: do something if the data dont change
    const updateData_b = updateLocalStorage_fb(path_as, data)


    // 2) call cbs
    getLocalData_f(path_as,
        () => {},
        (currentNode_cbs_o, currentNode_data_o, path_s, pathIndex_n) => {

            const currentData_o = currentNode_data_o != null ? currentNode_data_o[path_s] : null

            // last path
            if( currentNode_cbs_o[path_s].cbsData_byQuery_o
                && (currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s] != null )){
                    // || currentNode_cbs_o[path_s].cbsData_byQuery_o[{}])){   // listener to all

                currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].receivedData_b = true

                if(currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].cacheFallback_b || cacheFallback_b){

                    cacheServer_save_f(path_as, query_s, currentData_o)
                }

                obj_forEach_f(currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].cbData_byViewName_o, (cbData_f) => {    
                    
                    callCbWithData_f(currentData_o, query_os, cbData_f.childListener_b, path_as[pathIndex_n+1],  cbData_f.cb_f)
                })
            }
        })

}

// serverLocalStorage_dataChange_multiData_f
export const serverLocalStorage_dataChange_multiData_f = (localStorageMultiData_ac) => {


    // update data todo: do something if the data dont change
    let updateData_b = false
    localStorageMultiData_ac.forEach(dataPathAndQuery_c => {
        updateData_b = updateLocalStorage_fb(dataPathAndQuery_c.lsum_path_as, dataPathAndQuery_c.lsum_data_o) || updateData_b
    })

    let callCbs_byPath_b = {}
    // 2) call cbs
    localStorageMultiData_ac.forEach(dataPathAndQuery_c => {

        const query_s = obj_toString_fs(dataPathAndQuery_c.lsum_query_os)
        let cbPath_s = ''
        getLocalData_f(dataPathAndQuery_c.lsum_path_as,
            () => {},
            (currentNode_cbs_o, currentNode_data_o, path_s, pathIndex_n) => {

                let currentData_o = currentNode_data_o != null ? currentNode_data_o[path_s] : null
                cbPath_s += path_s
                // last path
                if (currentNode_cbs_o[path_s].cbsData_byQuery_o
                    && (currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s] != null)) {

                    currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].receivedData_b = true

                    if(callCbs_byPath_b[cbPath_s]){return}
                    callCbs_byPath_b[cbPath_s] = true

                    obj_forEach_f(currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].cbData_byViewName_o, (cbData_f) => {
                        callCbWithData_f(currentData_o, dataPathAndQuery_c.lsum_query_os, cbData_f.childListener_b, dataPathAndQuery_c.lsum_path_as[pathIndex_n + 1], cbData_f.cb_f)
                    })
                }
            })
    })
}

// serverStorage_listener_add_f
export const serverLocalStorage_listener_add_f = ({path_as, query_os={}, webView_s, childListener_b, cacheFallback_b, serverFuc_fn, cb_f}) => {

    const query_s = obj_toString_fs(query_os)
    let callServer = false


    getLocalData_f(path_as, (currentNode_cbs_o, currentNode_data_o, path_s) => {

        const currentData_o = currentNode_data_o ? currentNode_data_o[path_s] : null

        // debug
        if(gv_fun_env.storageDebugMode){

            if(debug_listeners_byPath_o[path_as.toString()+query_s] == null){
                debug_listeners_byPath_o[path_as.toString()+query_s] = [webView_s]
            }else{
                debug_listeners_byPath_o[path_as.toString()+query_s].push(webView_s)
            }

            if(obj_size_fn(debug_listeners_byPath_o) === 0){
                console.log("debug", "EMPTY - add")
            }else{
                console.log("debug", obj_size_fn(debug_listeners_byPath_o), obj_deepCopy_f(debug_listeners_byPath_o))
            }
        }
    
        // 1) first call
        if(currentNode_cbs_o[path_s].cbsData_byQuery_o == null || currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s] == null){

            if(currentNode_cbs_o[path_s].cbsData_byQuery_o == null){
                currentNode_cbs_o[path_s].cbsData_byQuery_o = {}
            }
            currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s] = {
                cbData_byViewName_o : {},
                receivedData_b : false,
            }
            callServer = true

        // 2) received data | reset listener
        }else if( currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s]
            && currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].cbData_byViewName_o == null){
            currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].cbData_byViewName_o = {}
            callServer = true
        }

        //  set cacheFlag
        const currentCacheFallback_b = currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].cacheFallback_b
        currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].cacheFallback_b = currentCacheFallback_b || cacheFallback_b
        
        //  3) add cbs
        currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].cbData_byViewName_o[webView_s] = {
            cb_f            : cb_f,
            childListener_b : childListener_b,
        }

        // 4) received data => call cb
        if(currentNode_cbs_o[path_s].cbsData_byQuery_o && currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].receivedData_b){
            callCbWithData_f(currentData_o, query_os, childListener_b, null, cb_f)
        }

        // 5) call server
        if(callServer){
            currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].index2_n = serverFuc_fn({
                cbError_f : () => {

                    const cacheData_o = cacheServer_get_fo(path_as, query_s)

                    serverLocalStorage_dataChange_f({path_as, query_os, data:cacheData_o})    

                }
            })
        }
    })

}

// serverStorage_listener_remove_f
export const serverLocalStorage_listener_remove_f = ({path_as, query_os, webView_c, serverRemove_f}) => {

    let query_s = obj_toString_fs(query_os)

    getLocalData_f(path_as, (currentNode_cbs_o, currentNode_data_o, path_s) => {

        if(currentNode_cbs_o[path_s].cbsData_byQuery_o == null || currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s] == null){
            console.log("serverStorage3_listener_remove_f", webView_c, path_as, query_s)
            return
        }

        // debug
        if(gv_fun_env.storageDebugMode) {
            if(debug_listeners_byPath_o[path_as.toString()+query_s]){
                let index = debug_listeners_byPath_o[path_as.toString()+query_s].indexOf(webView_c)
                debug_listeners_byPath_o[path_as.toString()+query_s].splice(1,index)
            }else{
                console.log("try to remove", path_as.toString()+query_s)
            }
        }

        // to for last path
        delete currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].cbData_byViewName_o[webView_c]

        if(validator_objEmpty_fb(currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].cbData_byViewName_o)){
            serverRemove_f(currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s].index2_n)
            delete currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s]

            // print localListeners
            if(gv_fun_env.storageDebugMode) {
                delete debug_listeners_byPath_o[path_as.toString()+query_s]
                if(obj_size_fn(debug_listeners_byPath_o) === 0){
                    console.log("EMPTY - remove")
                }else{
                    console.log(obj_size_fn(debug_listeners_byPath_o), obj_deepCopy_f(debug_listeners_byPath_o))
                }
            }
        }
    })

}

// serverStorage_listener_establishConnection_f
export const serverLocalStorage_listener_establishConnection_f = ({path_as, query_os}) => {

    let query_s = obj_toString_fs(query_os)

    getLocalData_f(path_as,
        () => {},
        (currentNode_cbs_o, currentNode_data_o, path_s) => {

            // dont recieved data => return null

            let currentData_o = currentNode_data_o != null ? currentNode_data_o[path_s] : null

            if(currentNode_cbs_o[path_s].cbsData_byQuery_o){

                let cb_data = currentNode_cbs_o[path_s].cbsData_byQuery_o[query_s]

                // establish connection but didnt received data
                if(cb_data && !cb_data.receivedData_b){
                    cb_data.receivedData_b = true

                    obj_forEach_f(cb_data.cbData_byViewName_o, (cbData_f) => {

                        callCbWithData_f(currentData_o, {}, cbData_f.childListener_b, null, cbData_f.cb_f)

                    })


                }
            }
        }
    )


}





// === Private Methods ====

// updateData_f
const updateLocalStorage_fb = (path_as, data) => {

    let currentNode_data_o = fbData_byJsonTree_o

    let pathNodes_byPathIndex = {}

    let updateData_b = false

    // 1) set data
    for(let i=0; i<path_as.length; i++){
        let path_s = path_as[i]

        pathNodes_byPathIndex[i] = currentNode_data_o

        // set/update data
        if(i === path_as.length-1) {

            // delete data
            if (data == null) {

                updateData_b = updateData_b || pathNodes_byPathIndex[i][path_s] != null
                delete pathNodes_byPathIndex[i][path_s]

                let j=i;
                while(j>0 && validator_objEmpty_fb(pathNodes_byPathIndex[j]) ){
                    updateData_b = updateData_b || pathNodes_byPathIndex[j-1][path_as[j]] != null
                    delete pathNodes_byPathIndex[j-1][path_as[j]]
                    j--;
                }

            //  update data
            }else if(validator_obj_fb(data) && currentNode_data_o[path_s] != null){
                for(let key in data){
                    updateData_b = updateData_b || !obj_equals_fb(currentNode_data_o[path_s][key], data[key])
                    currentNode_data_o[path_s][key] = data[key]
                }
            // set data
            }else{

                updateData_b = updateData_b || !obj_equals_fb(currentNode_data_o[path_s], data)
                currentNode_data_o[path_s] = data
            }

        }else{
            if(currentNode_data_o[path_s] == null){currentNode_data_o[path_s] = {}}
            currentNode_data_o = currentNode_data_o[path_s]
        }
    }

    return updateData_b
}

// callCbWithData_f
const callCbWithData_f = (data_o, query_os, childListener_b, childKey_s, cb_f) => {


    // child data, specific child
    if(childListener_b && childKey_s){

        cb_f(data_o[childKey_s], childKey_s)

        // all children
    } else if(childListener_b){


        obj_forEach_f(data_o, (childData_o, key) => {



            // null
            if(childData_o == null){
                return
            }

            // query startAt
            if(query_os.startAt && query_os.orderBy
                && childData_o[query_os.orderBy] < query_os.startAt){
                return
            }

            // query endAt
            if(query_os.endAt && query_os.orderBy
                && childData_o[query_os.orderBy] > query_os.endAt){
                return
            }

            cb_f(childData_o, key)
        })
    }else{

        if(validator_objEmpty_fb(data_o)){
            cb_f(null)
        }else if(validator_obj_fb(data_o)){
            let filterData_o = {}
            obj_forEach_f(data_o, (val, key_s) => {

                if(val == null) {
                    return
                }

                // query startAt
                if(query_os.startAt && query_os.orderBy
                    && val[query_os.orderBy] < query_os.startAt){
                    return
                }

                // query endAt
                if(query_os.endAt && query_os.orderBy
                    && val[query_os.orderBy] > query_os.endAt){
                    return
                }

                // query equalTo
                if(query_os.orderBy && query_os.equalTo
                    && val[query_os.orderBy] !== query_os.equalTo){
                    return
                }

                filterData_o[key_s] = val

            })
            cb_f(filterData_o)
        }else{
            cb_f(data_o)
        }
    }
}

// getData_f
const getLocalData_f = (path_as, onPathLastNodeDo_f, onEachNodeDo_f) => {

    let currentNode_cbs_o = cbs_byJsonTree_byViewName_o
    let currentNode_data_o = fbData_byJsonTree_o

    for(let i=0; i<path_as.length; i++){
        let path_s = path_as[i]

        if(currentNode_cbs_o[path_s] == null){currentNode_cbs_o[path_s] = {}}


        if(onEachNodeDo_f){
            onEachNodeDo_f(currentNode_cbs_o, currentNode_data_o, path_s, i)
        }

        // last path
        if(i === path_as.length-1){
            onPathLastNodeDo_f(currentNode_cbs_o, currentNode_data_o, path_s)
        }else{
            currentNode_cbs_o = currentNode_cbs_o[path_s]

            if(currentNode_data_o != null){currentNode_data_o = currentNode_data_o[path_s]}
        }
    }
}
